// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"adyen-response_pageTitle__1T41E","adyenHeader":"adyen-response_adyenHeader__1iq3L"};